import React from 'react';
import ModalContext from '../Context/ModalContext';
import ProductStockAdjustmentForm from '../../views/product/ProductsStockAdjustmentForm';
import FluentModal from './FluentModal';

type SupplierReturnStockAdjustmentModalProps = {
  open: boolean;
  onClose: (result?: any) => void;
  uuid: string;
};

/**
 * Modal wrapper for Stock Adjustment Form for use with Supplier Returns.
 */
const SupplierReturnStockAdjustmentModal = ({ open, onClose, uuid }: SupplierReturnStockAdjustmentModalProps) => {
  return (
    <ModalContext.Provider value={{ onClose }}>
      <FluentModal
        isOpen={open}
        styles={{
          main: {
            minWidth: '400px',
          },
          scrollableContent: { height: '94vh' },
        }}
        onDismiss={onClose}
      >
        <ProductStockAdjustmentForm
          match={{ params: { uuid } }}
          temporaryDefault={true}
          modalClose={true}
          onClose={onClose}
          addCapabilityOnly={true} //Indicates this can only be accessed from an 'adding an adjustment' context (I.e. Treat it as 'Add' for permissions).
          restricted
        />
      </FluentModal>
    </ModalContext.Provider>
  );
};

export default SupplierReturnStockAdjustmentModal;
